import { render, staticRenderFns } from "./Block4.vue?vue&type=template&id=25d2b99a&scoped=true&"
import script from "./Block4.vue?vue&type=script&lang=js&"
export * from "./Block4.vue?vue&type=script&lang=js&"
import style0 from "./Block4.vue?vue&type=style&index=0&id=25d2b99a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d2b99a",
  null
  
)

export default component.exports